module.exports = __webpack_public_path__ + "img/non-authenticated-shapes.d287a9a4.svg";